import jQuery from 'jquery';

const MODAL_ID = 'priceListModal';
let priceListModal = null;

// Проверяем, существует ли уже модальное окно
function initModal() {
  const modalElement = $('#' + MODAL_ID)[0];

  if (modalElement && !priceListModal) {
    priceListModal = new bootstrap.Modal(modalElement);
  }

  return modalElement;
}

function showPriceListModal() {
  const templateContent = $('#price-list-content').html();

  let modalElement = $('#' + MODAL_ID)[0];

  if (!modalElement) {
    const modalHTML = `
        <div class="modal fade" id="${MODAL_ID}" tabindex="-1">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              ${templateContent}
            </div>
          </div>
        </div>
      `;

    $('body').append(modalHTML);
    modalElement = $('#' + MODAL_ID)[0];
    priceListModal = new bootstrap.Modal(modalElement);
  } else {
    $('#' + MODAL_ID + ' .modal-content').html(templateContent);

    if (!priceListModal) {
      priceListModal = new bootstrap.Modal(modalElement);
    }
  }

  $(modalElement).off('shown.bs.modal').on('shown.bs.modal', function() {
    $(this).find('.js-order-btn').off('click').on('click', function() {
      alert('Заказ оформлен!');
      priceListModal.hide();
    });
  });

  priceListModal.show();
}

jQuery(function($) {
  $('.js-price-list').on('click', function() {
    showPriceListModal();
  });

  initModal();
});
